var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersLightBlueNoBgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.11133,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0001 4.61133C7.39782 4.61133 6.0751 5.87436 6.0751 7.46133C6.0751 9.04829 7.39782 10.3113 9.0001 10.3113C10.6024 10.3113 11.9251 9.04829 11.9251 7.46133C11.9251 5.87436 10.6024 4.61133 9.0001 4.61133ZM6.5251 11.8113C5.75373 11.8113 5.01127 12.1083 4.46174 12.6412C3.91174 13.1746 3.6001 13.9009 3.6001 14.6613C3.6001 14.8039 3.66767 14.9381 3.78225 15.0229L7.6501 17.7338C7.8498 17.8817 8.31377 18.1289 8.4617 17.9292C8.57161 17.7808 8.57669 17.5871 8.49012 17.4366H10.3501C10.3501 17.5423 10.3871 17.6483 10.4624 17.7338C10.6267 17.9203 10.9111 17.9383 11.0976 17.774L14.2476 14.999C14.3445 14.9136 14.4001 14.7906 14.4001 14.6613C14.4001 13.9009 14.0885 13.1746 13.5385 12.6412C12.9889 12.1083 12.2465 11.8113 11.4751 11.8113H6.5251Z",
    fill: "#5062F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.11133,
    r: 8.4,
    stroke: "#5062F0",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersLightBlueNoBgOutline);
export default __webpack_public_path__ + "static/media/usersLightBlueNoBgOutline.153fc03c7b9e88e80fb3e736bd7f1acb.svg";
export { ForwardRef as ReactComponent };